import React from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Link } from "react-router-dom";
import { localeShortDateTime } from "../../../../app/datetimeUtils";
import { scoreReportEssayLink } from "../../../../app/links";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { WritingUsage } from "./studentUsageReportApiSlice";

interface WritingTableProps {
	className?: string;
	essays: WritingUsage[];
}

export function WritingTable(props: WritingTableProps) {
	const dateTimeTemplate = (rowData: WritingUsage) => {
		return (
			<Link className="link" to={scoreReportEssayLink(rowData.essayId)}>
				{localeShortDateTime(rowData.lastUsedDate)}
			</Link>
		);
	};

	return (
		<DataTable
			value={props.essays}
			dataKey="essayId"
			loading={props.essays == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className ?? ""}`}>
			<Column
				header="Date"
				body={dateTimeTemplate}
				sortable
				sortField="lastUsedDate"></Column>
			<Column header="Prompt" field="promptName" sortable></Column>
			<Column header="Number of Drafts" field="draftCount" sortable></Column>
		</DataTable>
	);
}
